export default __webpack_public_path__ + "static/media/asset_history.1977e8fa.svg";